import React, { useState, useEffect } from 'react'
import './technicalskills.css'
import { getPortfolioConfig } from '../../firebase'

const TechnicalSkills = () => {
  const [skillCategories, setSkillCategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState('')
  const [autoRotate, setAutoRotate] = useState(true)

  useEffect(() => {
    let isMounted = true

    const loadSkills = async () => {
      const { skills: remoteSkills } = await getPortfolioConfig()

      if (isMounted) {
        setSkillCategories(remoteSkills)
        if (remoteSkills.length > 0) {
          setSelectedCategory(remoteSkills[0].id)
        }
      }
    }

    loadSkills()

    return () => {
      isMounted = false
    }
  }, [])

  const selected = skillCategories.find((cat) => cat.id === selectedCategory) || skillCategories[0]

  useEffect(() => {
    if (!autoRotate || skillCategories.length === 0) return undefined

    const interval = setInterval(() => {
      setSelectedCategory((prevCategory) => {
        const currentIndex = skillCategories.findIndex((cat) => cat.id === prevCategory)
        const safeIndex = currentIndex === -1 ? 0 : currentIndex
        const nextIndex = (safeIndex + 1) % skillCategories.length
        return skillCategories[nextIndex].id
      })
    }, 4000)

    return () => clearInterval(interval)
  }, [autoRotate, skillCategories])

  const handleCategoryClick = (id) => {
    setSelectedCategory(id)
    setAutoRotate(false)
  }

  if (!selected) {
    return (
      <section id="skills" className='card-container'>
        <h5>What I Work With</h5>
        <h2>Technical Skills</h2>
        <div className="container skills__container">
          <p className="text-light">Skill data is loading...</p>
        </div>
      </section>
    )
  }

  return (
    <section id="skills" className='card-container'>
      <h5>What I Work With</h5>
      <h2>Technical Skills</h2>

      <div className="container skills__container">
        <div className="skills__layout">
          <div className="skills__categories">
            {skillCategories.map((category) => (
              <button
                key={category.id}
                className={`skills__category-btn ${selectedCategory === category.id ? 'skills__category-btn--active' : ''}`}
                onClick={() => handleCategoryClick(category.id)}
                style={{
                  '--category-color': category.color
                }}
              >
                <span className="skills__category-indicator" style={{ backgroundColor: category.color }}></span>
                {category.title}
              </button>
            ))}
          </div>

          <div className="skills__display">
            <div className="skills__header">
              <h3 style={{ color: selected.color }}>{selected.title}</h3>
            </div>

            <div className="skills__tags">
              {(selected.skills || []).map((skill, idx) => (
                <span
                  key={idx}
                  className="skills__tag"
                  style={{ borderColor: selected.color }}
                >
                  {skill}
                </span>
              ))}
            </div>

            <div className="skills__use-cases">
              <span className="skills__use-case-label">Expertise in:</span>
              <div className="skills__use-case-items">
                {(selected.useCases || []).map((useCase, idx) => (
                  <span key={idx} className="skills__use-case-item">{useCase}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TechnicalSkills
